import React, { useState } from "react";

import { useMutation } from "@apollo/client";
import gql from "graphql-tag";
import { useNavigate } from "react-router-dom";
import FadeInWrapper from "../../../../components/common/fade-in-wrapper";
import BackArrow from "../../../../components/common/back-arrow";

const REGISTER_REFERRAL_CODE = gql`
  mutation registerReferralCode($referralCode: String!) {
    registerReferralCode(referralCode: $referralCode) {
      ok
      error
    }
  }
`;

const InviteRegister = () => {
  const [referralCode, setReferralCode] = useState("");
  const [showAuthButton, setShowAuthButton] = useState(false);

  const [registerReferralCode] = useMutation(REGISTER_REFERRAL_CODE);
  const navigate = useNavigate();

  const handleReferralCodeChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setReferralCode(value);
    setShowAuthButton(value.length === 8);
  };

  const handleVerifyAuthNumber = async () => {
    const response = await registerReferralCode({
      variables: { referralCode },
    });
    if (response.data.registerReferralCode.ok) {
      alert("등록이 완료되었습니다.");
      navigate("/my/invite/register/complete");
    } else {
      alert(response.data.registerReferralCode.error);
    }
  };

  return (
    <div className="h-full bg-white min-h-screen p-4">
      <FadeInWrapper className="flex flex-col h-full">
        <div onClick={() => navigate(-1)} className="p-1 mb-2">
          <BackArrow />
        </div>
        <h1 className="text-3xl text-black font-extrabold mt-4 mb-4">
          나를 추천한 친구의 <br />
          초대 코드를 입력해주세요
        </h1>
        <input
          type="text"
          value={referralCode}
          onChange={handleReferralCodeChange}
          placeholder="친구 초대 코드를 입력해주세요"
          className="border-b p-2 mb-4 w-full focus:outline-none"
          autoFocus
          maxLength={8}
        />
        {showAuthButton && (
          <FadeInWrapper className="inline w-full mt-4">
            <button
              onClick={handleVerifyAuthNumber}
              className={`w-full h-[60px] flex items-center justify-center rounded-3xl font-bold bg-[#C2FC8E] text-black`}
            >
              등록하기
            </button>
          </FadeInWrapper>
        )}
      </FadeInWrapper>
    </div>
  );
};

export default InviteRegister;
